import classNames from "classnames/dedupe";
import React from "react";
import Link from "../../ActionsSelectors/Link/Link";
import MediaBuilder from "../../Utility/MediaBuilder/MediaBuilder";
import { IBrandWallItemProps } from "./BrandWallItem.interface";

function BrandWallItem<LinkType = HTMLLinkElement>({
  id,
  mediaData,
  link: { classes: linkClasses, ...linkParams } = {},
  classes,
}: IBrandWallItemProps<LinkType>): JSX.Element {
  return (
    <Link<LinkType>
      key={id}
      classes={{
        root: classNames("brandwall-icon", classes?.root, linkClasses),
      }}
      {...(linkParams || {})}
    >
      <div>
        <MediaBuilder {...mediaData} />
      </div>
    </Link>
  );
}

export default BrandWallItem;
